import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import useDetailFetch from '../../../../hooks/useDetailFetch';

const CustomerSyncLogDetails = () => {
  const { logId } = useParams();
  const decodedId = logId ? atob(logId) : logId;
  const id = decodedId ? decodedId.replace(/\D/g, '') : '';

  const url = id ? `${API_DOMAIN}${API_ROUTES.customerSyncLog}${id}/` : null;
  const { data: log, loading } = useDetailFetch(url);

  const columns = useMemo(() => {
    if (!log) return [];
    const excluded = ['id', 'created_at', 'updated_at'];
    return Object.keys(log)
      .filter(k => !excluded.includes(k))
      .map(k => ({ label: k.charAt(0).toUpperCase() + k.slice(1).replace(/_/g, ' '), field: k }));
  }, [log]);

  return (
    <div>
      <SingleItemDetailTemplate
        details={log}
        columns={columns}
        loading={loading}
        entityName="Sync Log"
        listPath="/customer/sync-log/list"
      />
    </div>
  );
};

export default CustomerSyncLogDetails;
